module.exports = __webpack_public_path__ + "static/empty-frame@2x-min-a0cdbae456ebecd3abf3168db420de90.png";